import { defineStore } from 'pinia'
import { QUOTE_TYPES, QUOTE_NO_QUOTE_REASONS } from '@/data/url'
import apiClient from '@/services/apiClient'
import { unwrapApiData } from '@/services/apiEnvelope'

const initialState = () => ({
    search_action_customer: '',
    search_action_customer_ref: '',
    customer: [],
    vendor: [],
    uom: [],
    lead_days: [],
    user: [],
    extra_charge_type: [],
    quote_types: [],
    no_quote_reasons: [],
    condition_codes: [],
})

export const useDropdownsStore = defineStore('dropdowns', {
    state: () => initialState(),
    actions: {
        setDropdowns(dropdowns = {}) {
            this.customer = dropdowns.customer || []
            this.vendor = dropdowns.vendor || []
            this.lead_days = dropdowns.lead_days || []
            this.extra_charge_type = dropdowns.extra_charge_type || []
            this.uom = dropdowns.uom || []
            this.user = dropdowns.user || []
            this.quote_types = dropdowns.quote_types || []
            this.no_quote_reasons = dropdowns.no_quote_reasons || []
            this.condition_codes = dropdowns.condition_codes || []
        },
        addCustomer(customer) {
            const normalizedCustomer = (customer || '').toString().trim()
            if (!normalizedCustomer) {
                return
            }
            const hasCustomer = this.customer.some(
                (item) => item.toLowerCase() === normalizedCustomer.toLowerCase()
            )
            if (!hasCustomer) {
                this.customer = [...this.customer, normalizedCustomer].sort((a, b) =>
                    a.localeCompare(b)
                )
            }
        },
        setSearchActionCustomer(customer) {
            this.search_action_customer = customer
        },
        setSearchActionCustomerRef(customer_ref) {
            this.search_action_customer_ref = customer_ref
        },
        setQuoteTypes(quoteTypes) {
            this.quote_types = quoteTypes || []
        },
        setNoQuoteReasons(noQuoteReasons) {
            this.no_quote_reasons = noQuoteReasons || []
        },
        async fetchQuoteTypes() {
            if (this.quote_types.length > 0) {
                return
            }
            try {
                const response = await apiClient.get(QUOTE_TYPES)
                this.setQuoteTypes(unwrapApiData(response, []))
            } catch (error) {
                console.error('Error fetching quote types:', error)
            }
        },
        async fetchNoQuoteReasons() {
            if (this.no_quote_reasons.length > 0) {
                return
            }
            try {
                const response = await apiClient.get(QUOTE_NO_QUOTE_REASONS)
                this.setNoQuoteReasons(unwrapApiData(response, []))
            } catch (error) {
                console.error('Error fetching no quote reasons:', error)
            }
        }
    },
})
